import { KeycloakService } from 'keycloak-angular';
import { KeycloakStateService } from '../service/utility.service';
import { environment } from '@env';

const TOKEN_REFRESH_INTERVAL_MS = 15_000;
const TOKEN_MIN_VALIDITY_SECONDS = 60;

export function initializeKeycloak(
  keycloak: KeycloakService,
  keycloakStateService: KeycloakStateService
): () => Promise<boolean> {

  return async (): Promise<boolean> => {
    try {
      const isLoggedIn = await keycloak.init({
        config: {
          url: environment.keyCloakUri,
          realm: environment.keyCloakRealm,
          clientId: environment.keyCloakClientId
        },

        initOptions: {
          onLoad: 'check-sso',

          silentCheckSsoRedirectUri:
            window.location.origin +
            '/assets/silent-check-sso.html',

          checkLoginIframe: false
        },

        // Adds the bearer token to eligible HTTP requests.
        enableBearerInterceptor: true,

        // Requests matching these exclusions do not receive the token.
        bearerExcludedUrls: [
          '/assets',
          '/public'
        ]
      });

      /*
       * Start the refresh loop regardless of the initial login state.
       * This allows the loop to detect an authenticated session after
       * the application completes a subsequent login and reloads.
       */
      startTokenRefreshLoop(keycloak);

      if (!isLoggedIn) {
        console.log('User is not logged in.');

        return false;
      }

      console.log(
        'User is logged in. Executing on-load logic.'
      );

      const userProfile =
        await keycloak.loadUserProfile();

      const token =
        await keycloak.getToken();

      if (token) {
        const decodedToken = decodeToken(token);

        const sessionId =
          decodedToken.session_state;

        const userId =
          decodedToken.sub;

        const organizationId =
          decodedToken.organizationId;

        const realmRoles: string[] =
          decodedToken.realm_access?.roles ?? [];

        keycloakStateService.setSessionId(sessionId);

        keycloakStateService.setUserId(userId);

        keycloakStateService.setOrganizationId(
          organizationId
        );

        keycloakStateService.setRealmRoles(
          realmRoles
        );

        keycloakStateService.sendTokenToBackend();

                  // keycloakStateService
          //   .termsAndConditionsVerify()
          //   .subscribe((res) => console.log("T&C verify result", res));

          // const response = await keycloakStateService
          //   .generateTransactionId()
          //   .toPromise();

        console.log('Session Id:', sessionId);
        console.log('User Id:', userId);
        console.log('Organization Id:', organizationId);
        console.log('Realm Roles:', realmRoles);
        console.log('User Profile:', userProfile);
      }

      return true;

    } catch (error) {
      console.error(
        'Keycloak initialization failed:',
        error
      );

      return false;
    }
  };
}


/**
 * Automatically refresh the access token before it expires.
 *
 * Check interval: 15 seconds.
 * Refresh threshold: 60 seconds of remaining token validity.
 *
 * A successful refresh does not interrupt navigation.
 * A failed refresh initiates Keycloak authentication.
 */
function startTokenRefreshLoop(
  keycloak: KeycloakService
): void {

  let refreshInProgress = false;

  let reauthenticationInProgress = false;

  const refreshIfNeeded = async (): Promise<void> => {

    if (
      refreshInProgress ||
      reauthenticationInProgress
    ) {
      return;
    }

    refreshInProgress = true;

    try {

      const isLoggedIn =
        await keycloak.isLoggedIn();

      // Do not attempt a refresh without an authenticated session.
      if (!isLoggedIn) {
        return;
      }

      /*
       * Refresh only when the token expires within
       * the next 60 seconds.
       *
       * updateToken() returns:
       * true  -> the token was refreshed
       * false -> the existing token was still sufficiently valid
       */
      const refreshed =
        await keycloak.updateToken(
          TOKEN_MIN_VALIDITY_SECONDS
        );

      if (refreshed) {
        console.log(
          'Access token refreshed successfully.'
        );
      }

    } catch (error) {

      console.error(
        'Access token refresh failed.',
        error
      );

      reauthenticationInProgress = true;

      // Clear the invalid local authentication state.
      keycloak.clearToken();

      // Preserve the current route after authentication.
      const redirectUri = window.location.href;

      try {

        await keycloak.login({
          redirectUri
        });

      } catch (loginError) {

        console.error(
          'Unable to redirect to Keycloak login.',
          loginError
        );

        // Allow another attempt if the login redirect failed.
        reauthenticationInProgress = false;
      }

    } finally {

      refreshInProgress = false;

    }
  };

  // Perform an initial check.
  void refreshIfNeeded();

  // Check periodically while the application is open.
  window.setInterval(() => {
    void refreshIfNeeded();
  }, TOKEN_REFRESH_INTERVAL_MS);
}


/**
 * Decode the JWT payload.
 */
function decodeToken(token: string): any {

  if (!token || !token.includes('.')) {
    return {};
  }

  try {

    const payload = token.split('.')[1];

    // JWT payloads use Base64URL encoding.
    const base64 = payload
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const paddedBase64 = base64.padEnd(
      base64.length +
        ((4 - (base64.length % 4)) % 4),
      '='
    );

    return JSON.parse(
      atob(paddedBase64)
    );

  } catch (error) {

    console.error(
      'Token decode failed:',
      error
    );

    return {};
  }
}



// import { KeycloakService } from "keycloak-angular";
// import { KeycloakStateService } from "../service/utility.service";
// import { environment } from "@env";

// export function initializeKeycloak(
//   keycloak: KeycloakService,
//   keycloakStateService: KeycloakStateService
// ): () => Promise<boolean> {
//   return () =>
//     keycloak
//       .init({
//         config: {
//           url: environment.keyCloakUri,
//           realm: environment.keyCloakRealm,
//           clientId: environment.keyCloakClientId
//         },
//         initOptions: {
//           onLoad: "check-sso",
//           silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
//           checkLoginIframe: false
//         },
//         enableBearerInterceptor: true, // ✅ auto-refresh before HTTP calls
//         bearerExcludedUrls: ["/assets", "/public"], // optional exclusions
//       })
//       .then(async () => {
//         const isLoggedIn = await keycloak.isLoggedIn();

//         if (isLoggedIn) {
//           console.log("User is logged in. Executing on-load logic.");

//           const userProfile = await keycloak.loadUserProfile();
//           // await keycloak.updateToken(30);
//           const token = await keycloak.getToken();
          
//           if (token) {
//                const decodedToken = decodeToken(token);
//                   const sessionId = decodedToken.session_state;
//           const userId = decodedToken.sub;
//           const organizationId = decodedToken.organizationId;
//           const realmRoles = decodedToken.realm_access?.roles || [];



//           keycloakStateService.setSessionId(sessionId);
//           keycloakStateService.setUserId(userId);
//           keycloakStateService.setOrganizationId(organizationId);
//           keycloakStateService.setRealmRoles(realmRoles);
//           keycloakStateService.sendTokenToBackend();

//           // keycloakStateService
//           //   .termsAndConditionsVerify()
//           //   .subscribe((res) => console.log("T&C verify result", res));

//           // const response = await keycloakStateService
//           //   .generateTransactionId()
//           //   .toPromise();

//                console.log("Session Id", sessionId);
//           console.log("User Id", userId);
//           console.log("Organization Id", organizationId);
//           console.log("Realm Roles", realmRoles);
//           // console.log("Transaction Id", response);
//           console.log("User Profile:", userProfile);
//            }
//         } else {
//           console.log("User is not logged in.");
//         }
//         return isLoggedIn;
//       })
//       .catch((err: any) => {
//         console.error("Keycloak initialization failed", err);
//         return false;
//       });
// }

// function decodeToken(token: string): any {
//       if (!token || !token.includes(".")) return {};

//     try {
//       const payload = token.split(".")[1];
//       return JSON.parse(atob(payload));
//     } catch (e) {
//       console.error("Token decode failed:", e);
//       return {};
//     }
// }